import type { BatchPreviewState, BatchPreviewType } from "./batch-preview.type";

import { useSearchParams } from "react-router";

import { getBatchPreviewIds } from "./batch-preview.helper";

export const useBatchPreviewTypeParam = () => {
  const [searchParams] = useSearchParams();

  const type = searchParams?.get("type");

  return type ? (type as BatchPreviewType) : undefined;
};

export const useBatchPreviewStateParam = <
  State extends BatchPreviewState = BatchPreviewState,
>() => {
  const [searchParams] = useSearchParams();

  return (searchParams?.get("state") ?? "") as State;
};

export const useBatchPreviewIdsParam = () => {
  const [searchParams] = useSearchParams();

  const idsParam = searchParams?.get("ids") ?? "";
  const ids = getBatchPreviewIds(idsParam);

  return { ids, idsParam };
};

export const useBatchPreviewGetUserName = () => {
  const [searchParams] = useSearchParams();
  const userName = searchParams?.get("user_name");

  return {
    userName,
  };
};
